import React from 'react';

const steps = [
  { n: '01', t: 'Intent Signal', b: 'Browser behavior, dwell time, scroll depth, product affinity — captured per visitor in real-time.' },
  { n: '02', t: 'AI Scoring', b: '100+ variables fed into a purchase-intent model. Every visitor receives a buyer intent score.' },
  { n: '03', t: 'Dynamic Creative', b: "Personalized ad built on-the-fly from the shopper's browsing history and your brand system." },
  { n: '04', t: 'Proactive Bid', b: 'Real-time bid optimization across premium DSP inventory — milliseconds from signal to impression.' },
  { n: '05', t: 'Convert + Track', b: 'Verified sale recorded. Attribution locked. You pay only at this moment — not a second sooner.' },
];

export default function PipelineSection() {
  return (
    <section className="highlights-section" id="pipeline" data-testid="pipeline-section">
      <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360">
        <div className="highlights-kicker">
          <span />THE AI PIPELINE
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start">
          <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626]">
            From Intent To <span className="accent">Conversion</span>
          </h2>
          <div className="lg:col-span-5">
            <p className="reveal-on-scroll sec-subhead leading-relaxed">
           From the instant a visitor lands, our five-stage AI pipeline identifies, scores, creates, bids, and converts in milliseconds. Continuous multivariate testing optimises every touchpoint automatically—delivering faster wins, higher ROI, and fully managed growth.
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-0 border-t border-l border-[#1a1a1a]">
          {steps.map((s, i) => (
            <div
              key={s.n}
              className="p-5 lg:p-7 border-r border-b border-[#1a1a1a] relative group transition-colors bg-white/70"
            >
              <div className="text-[0.95rem] font-bold font-mono text-[#ff5117] mb-3">STEP {s.n}</div>
              <div className="font-display font-bold text-[28px] lg:text-[24px] leading-tight mb-3">{s.t}</div>
              <p className="sec-subhead leading-relaxed">{s.b}</p>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 right-[-10px] w-5 h-[1px] bg-[#ff5117] z-index-[5]" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
